import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

interface AddColorStylesProps {
  disabled: boolean
}
const useStyles = makeStyles<Theme, AddColorStylesProps>(theme => ({
  colorBox: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer')
  },

  picker: {
    background: `${theme.palette.divider}`,
    boxShadow: `0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%) !important`
  }
}))

export default useStyles
